import { Box, Breadcrumbs } from '@mui/material';
import React from 'react';

/** Renders a list of title items as breadcrumb-style segments with "/" separator. */
export function PageTitleItems({ items }: { items: React.ReactNode | React.ReactNode[] }) {
  return (
    <Breadcrumbs
      separator={
        <Box color="text.disabled" fontWeight="400" mx={0.75}>
          /
        </Box>
      }
      sx={{
        fontSize: '1.1rem',
        fontWeight: '500',
        color: 'text.primary',
        '& a': {
          color: 'text.primary',
        },
      }}
    >
      {(Array.isArray(items) ? items : [items]).map((item, index) => {
        return <React.Fragment key={index}>{item}</React.Fragment>;
      })}
    </Breadcrumbs>
  );
}
